import React from 'react';

const SpinnerDark = () => {
    return (
        <div className="flex min-h-[50vh] items-center justify-center">
            <div
                className="h-10 w-10 animate-spin rounded-full border-2 border-cream-200 border-t-pine-700"
                role="status"
                aria-label="Загрузка"
            />
        </div>
    );
};

export default SpinnerDark;
